export const KNOCK_KNOCK_COOKIE_NAME = 'knockknock';
export const KNOCK_KNOCK_COOKIE_VALUE = 'batebate';
export const KNOCK_KNOCK_PARENT_DOMAIN = 'exis.pro';

function decodeCookieComponent(value: string): string {
  try {
    return decodeURIComponent(value);
  } catch {
    return value;
  }
}

function normalizeCookieName(rawName: string): string {
  return decodeCookieComponent(rawName.trim()).replace(/\+/g, ' ');
}

function decodeCookieValue(rawValue: string): string {
  const trimmed = rawValue.trim();
  const unquoted =
    trimmed.length >= 2 && trimmed.startsWith('"') && trimmed.endsWith('"')
      ? trimmed.slice(1, -1)
      : trimmed;
  return decodeCookieComponent(unquoted);
}

export function cookieValue(
  name: string,
  cookieSource = '',
): string | undefined {
  if (!cookieSource) {
    return undefined;
  }

  for (const part of cookieSource.split(';')) {
    const trimmed = part.trim();
    if (!trimmed) {
      continue;
    }
    const eq = trimmed.indexOf('=');
    const rawName = eq === -1 ? trimmed : trimmed.slice(0, eq);
    const rawValue = eq === -1 ? '' : trimmed.slice(eq + 1);
    if (normalizeCookieName(rawName) === name) {
      return decodeCookieValue(rawValue);
    }
  }
  return undefined;
}

export function hasKnockKnockCookie(cookieSource = ''): boolean {
  return (
    cookieValue(KNOCK_KNOCK_COOKIE_NAME, cookieSource) ===
    KNOCK_KNOCK_COOKIE_VALUE
  );
}

export function isKnockKnockUnlockQuery(search: string): boolean {
  const params = new URLSearchParams(
    search.startsWith('?') ? search.slice(1) : search,
  );
  return params.get(KNOCK_KNOCK_COOKIE_NAME) === KNOCK_KNOCK_COOKIE_VALUE;
}

export function knockKnockSetCookie(hostname: string): string {
  const parts = [
    `${KNOCK_KNOCK_COOKIE_NAME}=${KNOCK_KNOCK_COOKIE_VALUE}`,
    'Path=/',
    'Max-Age=31536000',
    'SameSite=Lax',
  ];
  if (isExisProHost(hostname)) {
    parts.push(`Domain=.${KNOCK_KNOCK_PARENT_DOMAIN}`, 'Secure');
  }
  return parts.join('; ');
}

export function isExisProHost(hostname: string): boolean {
  return (
    hostname === KNOCK_KNOCK_PARENT_DOMAIN ||
    hostname.endsWith(`.${KNOCK_KNOCK_PARENT_DOMAIN}`)
  );
}

export function persistSharedKnockKnockCookie(
  hostname: string,
  cookieSource: string,
  setCookie: (value: string) => void,
): void {
  if (!hasKnockKnockCookie(cookieSource) || !isExisProHost(hostname)) {
    return;
  }
  setCookie(knockKnockSetCookie(hostname));
}
